<template>
    <div style="width: 100%;" >
        <md-card class="md-card-chart">
            <md-card-header class="md-card-header-icon">
                <slot name="header"></slot>
            </md-card-header>
            <md-card-content class="md-layout md-alignment-center-center">
                <div class="md-layout-item md-xsmall-size-100" :class="[
                    `md-size-${data ? 50 : 100}`,
                    `md-small-size-${data ? 50 : 100}`,
                    `md-large-size-${data ? 45 : 100}`,
                    `md-xlarge-size-${data ? 40 : 100}`
                    ]">
                    <slot :styleValue="{height: height}"></slot>
                </div>
                <div v-if="data" class="md-layout-item md-size-50 md-xlarge-size-60 md-large-size-55 md-small-size-50 md-xsmall-hide">
                    <md-content class="md-scrollbar card-dashboard-wings__legend" style="max-height: 200px; overflow-y: auto">
                        <div v-for="(item,index) in data" :key="index">
                            <i v-if="item.itemStyle" :style="{'color':item.itemStyle.color}" class="md-icon md-small">circle</i>
                            <i v-else :style="{'color':useColors[index]}" class="md-icon md-small">circle</i>
                            <span>
                                <slot name="legend" :legend="item" :percent="percent(item)">{{item.name}}</slot>
                            </span>
                        </div>
                    </md-content>
                </div>
            </md-card-content>
            <md-card-actions md-alignment="right" v-if="!noFooter">
                <slot name="footer"></slot>
                <md-button class="md-button md-simple md-just-icon" @click="classicModal = true">
                    <md-icon>aspect_ratio</md-icon>
                </md-button>
            </md-card-actions>
        </md-card>
        <modal v-if="classicModal" @close="classicModal = false">
            <template slot="header">
                <h4 class="modal-title">
                    <slot name="header"></slot>
                </h4>
                <md-button class="md-danger md-simple md-just-icon md-round modal-default-button" @click="classicModal = false">
                    <md-icon>clear</md-icon>
                </md-button>
            </template>
            <template slot="body">
                <div class="md-layout md-alignment-center-center">
                    <div class="md-layout-item md-xsmall-size-100" :class="[`md-size-${data ? 70 : 100}`]">
                        <slot :styleValue="{height: heightForModal}"></slot>
                    </div>
                    <div v-if="data" class="md-layout-item md-size-30 md-xsmall-size-100 card-dashboard-wings__legend">
                        <div v-for="(item,index) in data" :key="index">
                            <i v-if="item.itemStyle" :style="{'color':item.itemStyle.color}" class="md-icon md-small">circle</i>
                            <i v-else :style="{'color':useColors[index]}" class="md-icon md-small">circle</i>
                            <span>
                                <slot name="legend" :styleValue="{height: heightForModal}" :legend="item" :percent="percent(item)">{{item.name}}</slot>
                            </span>
                        </div>
                    </div>
                </div>
            </template>
            <template slot="footer">
            </template>
        </modal>
    </div>
</template>
<script>
import {Modal} from "@/components";

export default {
  components:{Modal},
  name: "chartCardWings",
  props: {
    noFooter: Boolean,
    data: Array,
  },
  data() {
    return {
      classicModal: false,
      height: '200px',
      heightForModal: '80vh',
      colors:[],
      colors2:['#37a2da','#fdd85c'],
      colors5:['#37a2da','#67e0e3','#fdd85c','#fc9f7f','#e062ae'],
      colors8:['#37a2da','#32c5e9','#9fe6b8','#fddb5c','#fc9f7f','#fb7193','#e7bcf3','#8278ea'],
      colorsNew:['#37a2da','#32c5e9','#67e0e3','#9fe6b8','#fddb5c','#fc9f7f','#fb7193','#e062ae',"#e690d1",'#e7bcf3','#9d96f5','#8278ea','#95bfff'],
    };
  },
  computed: {
    useColors(){
      if (this.data.length <= 2) return this.colors2;
      if (this.data.length <= 5) return this.colors5;
      if (this.data.length <= 8) return this.colors8;
      return this.colorsNew
    }
  },
  methods: {
    percent(item){
      let total = 0;
      this.data.forEach(row => {
        total+= row.value
      });
      return (item.value / total * 100).toFixed(2)
    }
  },
  mounted() {}
};
</script>
<style scoped>
    .md-card-content {
        font-size: 15px !important;
        font-weight: 400 !important;
    }
    .md-card-actions {
        margin:auto 5px 10px !important;
        height: 32px !important;
    }
    .modal-body {
        font-weight: 400 !important;
    }
</style>